import * as React from 'react';
import { memo } from 'react';
import {
  Box,
  StackLayout,
  styled,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import {
  ImpersonationTopBanner,
  AppBarHeader,
} from '@leagueplatform/web-common-components';
import { logout } from 'utils/auth/logout';
import { AccountModals } from 'components/modals/account-modals.component';
// import { AppLoadingSkeleton } from 'components/loaders/app-loading-skeleton.component';
import { usePersonalInformation } from 'hooks/use-personal-information.hook';
import { useNavBarLogic } from 'hooks/use-navbar-logic.hook';
import { useNavLinksList } from 'hooks/useNav-links.hook';
import { useModal } from 'hooks/use-modal.hook';
import cignaLogo from 'assets/cigna-logo.svg';
import { MainNav } from './main-nav.component';
import { MobileNavWrapper } from './mobile-nav/mobile-nav-wrapper.component';

const Logo = styled('img', {
  width: '74px',
  height: '40px',
  margin: 'auto 70px auto 32px',
});

const APP_NAV_DEFAULT_HEIGHT = 64;

export const AppNavBarComponent: React.FC = memo(() => {
  const { showClaims } = usePersonalInformation();
  const { navLinks } = useNavLinksList(showClaims);
  const { menuOpen, toggleMenu, closeMenu, handleLogoClick } = useNavBarLogic();
  const isAboveLaptop = useMediaQuery(queryHelpers.up('laptop'));

  // Modal state management
  const {
    isShowing: showDeleteAccountModal,
    toggle: toggleDeleteAccountModal,
  } = useModal();
  const {
    isShowing: showAccountDeletedModal,
    toggle: toggleAccountDeletedModal,
  } = useModal();

  const handleLogout = () => logout(window.location.origin);

  return (
    <>
      <StackLayout
        orientation="horizontal"
        horizontalAlignment="spaceEvenly"
        verticalAlignment="center"
        css={{
          position: 'sticky',
          top: 0,
          width: '100vw',
          left: 0,
          zIndex: '$toast',
        }}
      >
        <ImpersonationTopBanner />
      </StackLayout>

      <Box
        css={{
          '> header > nav > ul > li > a[aria-current="page"]::after': {
            backgroundColor: '$interactiveActionPrimary',
          },
        }}
      >
        <AppBarHeader navHeight={APP_NAV_DEFAULT_HEIGHT}>
          <Logo src={cignaLogo} alt="Cigna Logo" onClick={handleLogoClick} />
          {isAboveLaptop ? (
            <>
              {/* This is only in impersonation mode: Impersonators will see a static top banner indicating that they are impersonating a member. */}
              <MainNav
                navLinks={navLinks}
                handleDeleteAccount={toggleDeleteAccountModal}
              />
            </>
          ) : (
            <MobileNavWrapper
              navLinks={navLinks}
              menuOpen={menuOpen}
              toggleMenu={toggleMenu}
              closeMenu={closeMenu}
              handleDeleteAccount={toggleDeleteAccountModal}
            />
          )}
        </AppBarHeader>
        <AccountModals
          onLogout={handleLogout}
          showDeleteAccountModal={showDeleteAccountModal}
          toggleDeleteAccountModal={toggleDeleteAccountModal}
          showAccountDeletedModal={showAccountDeletedModal}
          toggleAccountDeletedModal={toggleAccountDeletedModal}
        />
      </Box>
    </>
  );
});

AppNavBarComponent.displayName = 'AppNavBarComponent';
